import type { RailingCatalogSettings } from "building-types/settings/railingCatalogSettings";
import type { RailingBase, RailingDefaultSetting } from "building-types/settings/railingTypes";
import {
  DefaultBaluster,
  DefaultPost,
  DefaultRail,
  RailingInfillStyle,
  RailingSettingsType,
} from "building-types/settings/railingTypes";
import { SettingsType } from "building-types/settings/settingsType";
import { defaultRailingViewNotes } from "doc/settings/defaultViewNoteSettings";

// TODO: Nathan/Andrew default keys here and in stairConstants should be
// generated at runtime
export const defaultRailingSettingKey = "2NrKVa2FQowH90I7";

export const defaultRailingDrawingSettings = {
  includeRailInShowRoomPlan: true,
  includeRailInPlanDrawing: true,
  includeRailInBrochurePlan: true,
  includePostsInShowRoomPlan: true,
  includePostsInPlanDrawing: true,
  includePostsInBrochurePlan: true,
};

export const defaultRailingBase: RailingBase = {
  levelId: "",
  path: null,
  railingSettingId: defaultRailingSettingKey,
  settingsOverride: defaultRailingDrawingSettings,
};

export const defaultRailingSetting: RailingDefaultSetting = {
  type: RailingSettingsType.RAILING_DEFAULT,
  catalogItemType: "RAILING_SETTING",
  entityType: "RAILING_SETTING",
  id: defaultRailingSettingKey,
  name: "Default Railing",
  sortIndex: 0,

  hasTopRail: true,
  topRailHeight: 30,
  topRail: DefaultRail,

  hasBottomRail: true,
  bottomRailHeight: 4,
  bottomRail: DefaultRail,

  hasPosts: true,
  removeStartPost: true,
  removeEndPost: true,
  post: DefaultPost,
  postHeight: 28.5,

  infillStyle: RailingInfillStyle.BALUSTERS,
  infillDepth: 1.5,
  baluster: DefaultBaluster,

  viewNotes: defaultRailingViewNotes,
};

export const defaultRailingSettings: RailingCatalogSettings = {
  type: SettingsType.RAILING_CATALOG_SETTINGS,
  name: "",
  railingSettingsTable: {
    [defaultRailingSettingKey]: defaultRailingSetting,
  },
};
